import { action, type ActionMessage } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface OpenTodayActionMessage extends ActionMessage {
    readonly mailboxInfo: MailboxInfo;
}

export const openToday: (mailboxInfo: MailboxInfo) => OpenTodayActionMessage = action(
    'openToday',
    (mailboxInfo: MailboxInfo) => ({ mailboxInfo })
);
